export default "__VITE_ASSET__CtIMwdYV__"